import { withInstall } from '../_util'

import TableSelectPagetable from './TableSelectPagetable.vue'

export default withInstall(TableSelectPagetable, {})
